import { render, staticRenderFns } from "./call.vue?vue&type=template&id=5071f5a6&scoped=true"
import script from "./call.vue?vue&type=script&lang=js"
export * from "./call.vue?vue&type=script&lang=js"
import style0 from "./call.vue?vue&type=style&index=0&id=5071f5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071f5a6",
  null
  
)

export default component.exports